export const UNSET_GOAL_TARGET = 0;

const hasText = (value) => Boolean(String(value || "").trim());

// A target of 1 with no title/description is the legacy default placeholder, not a real goal.
export const hasEstablishedGoalTarget = (goalTracker) => {
    const targetAmount = Number(goalTracker?.targetAmount) || 0;
    if (targetAmount > 1) return true;
    if (targetAmount !== 1) return false;
    return hasText(goalTracker?.title) || hasText(goalTracker?.description);
};
